module.exports = __webpack_public_path__ + "static/img/jpcomma.395ffa1c.png";